import { ConstrainedString } from '../generic'
import { PollId } from '../Poll'
import { Timestamp } from '../Timestamp'

export type BallotId = ConstrainedString<'ballot-id'>

export enum VoteMethod {
  Automatic = 'automatic',
  Manual = 'manual',
}

export interface Ballot {
  id: BallotId
  pollId: PollId
  createTime: Timestamp
  expirationTime: Timestamp
  investorVote?: {
    response: InvestorVoteResponse
    responseTime: Timestamp
    voteMethod: VoteMethod
  }
  comment?: BallotComment
}

interface BallotComment {
  content: string
  createTime: Timestamp
}

export type InvestorVoteResponse = 'for' | 'against' | 'abstain' | 'withhold' | 'no_action'
